import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { PriceHelper } from '../helpers/PriceHelper';
import { BaseComponent } from '../classes/BaseComponent';
import { StringHelper } from '../helpers/StringHelper';
import { Global } from '../classes/Global';

@Component({
  selector: 'app-range-slider',
  templateUrl: './range-slider.component.html',
  styleUrls: ['./range-slider.component.scss']
})
export class RangeSliderComponent extends BaseComponent implements OnInit {

  @Input() min: number;
  @Input() max: number;

  @Input() minValue: number;
  @Input() maxValue: number;

  @Output() onSlide = new EventEmitter();

  @Input() isPrice: boolean = false;

  constructor(
  ) {
    super();
  }

  ngOnInit() {
  }

  rangeInputChangeEventHandler(e){
      let minBtn = e.target.parentElement.getElementsByClassName('min')[0];
      let maxBtn = e.target.parentElement.getElementsByClassName('max')[0];
      let minVal = parseInt(minBtn.value);
      let maxVal = parseInt(maxBtn.value);
      let origin = e.target.className.split(' ')[0];

      if(origin === 'min' && minVal > maxVal - 1){
          minBtn.value = maxVal - 1;
      }
      minVal = parseInt(minBtn.value);
      this.minValue = minVal;

      if(origin === 'max' && maxVal - 1 < minVal){
          maxBtn.value = minVal + 1;
      }
      maxVal = parseInt(maxBtn.value);
      this.maxValue = maxVal;

      this.onSlide.emit({min:this.minValue, max:this.maxValue});
  }

  formatPrice(value:number) {
    if(value == this.max){
      return PriceHelper.formatPrice(value, Global.countries[Global.getCountry()].currency, true, true, false);
    }
    else if(this.maxValue == this.max && value != this.max) {
      return StringHelper.format(this.getString('priceRange_over'), PriceHelper.formatPrice(value, Global.countries[Global.getCountry()].currency, true, true, false));
    }
    else {
      return PriceHelper.formatPrice(value, Global.countries[Global.getCountry()].currency, true, true, false);
    }
  }

  getMinValue(): number {
    return this.minValue;
  }

  getMaxValue(): number {
    return this.maxValue;
  }

}
